import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { lighten } from 'polished';
import {
  colorAccent,
  colorHover,
  colorText,
  sidebarColor,
  colorRed,
  colorGray,
} from '@/utils/palette';
import {
  left,
  marginLeft,
  marginRight,
} from '@/utils/directions';
import { SideBarRefreshContext } from '../../../../context/SideBarRefreshContext';

// Create a session storage key based on route
const getClickCountKey = route => `sidebar_click_count_${route}`;

const SidebarLink = ({
  title, icon, newLink, route, onClick, color,
}) => {
  const location = useLocation();
  const clickCountKey = getClickCountKey(route);
  
  // Track if this is the first click or not
  const [clickCount, setClickCount] = useState(0);
  const { sideBarRefresh, setSideBarRefresh } = useContext(SideBarRefreshContext);
  
  // Initialize click count from session storage when component mounts
  useEffect(() => {
    const storedCount = sessionStorage.getItem(clickCountKey);
    if (storedCount) {
      setClickCount(parseInt(storedCount, 10));
    }
  }, [clickCountKey]);

  const handleClick = (e) => {
    // Get current count from state
    const currentCount = clickCount + 1;
    
    // Update count in state and session storage
    setClickCount(currentCount);
    sessionStorage.setItem(clickCountKey, currentCount.toString());
    
    // Call the provided onClick handler
    if (onClick) {
      onClick(e);
    }

    // // If this is not the first click and current route matches the target route, force refresh
    // if (currentCount > 1 && location.pathname === route) {
    //   e.preventDefault();
    //   window.location.href = route;
    // }
    // // First click will use default NavLink behavior

    //  First click: normal NavLink behavior
    // Subsequent clicks on same route: just log the route
    if (currentCount > 1 && location.pathname === route) {
      console.log('Navigated again to:', route);
    }
  };

  // Effect for click for second time in same Route for should be refresh that page
  useEffect(() => {
    if (clickCount > 1) {
      // For Restaurant Details 
      if (location.pathname === '/admin/agent') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminAgentRefresh: !prevState.adminAgentRefresh,
        }));
      }
      // For Restaurant Meal 
      if (location.pathname === '/admin/agentrequest') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminAgentRequestRefresh: !prevState.adminAgentRequestRefresh,
        }));
      }
      // For Restaurant Meal Request
      if (location.pathname === '/admin/agentRejectedRequest') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminAgentRejectedRefresh: !prevState.adminAgentRejectedRefresh,
        }));
      }
      // For Restaurant Meal Rejected Request Refresh
      if (location.pathname === '/admin/restaurant') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminRestaurantRefresh: !prevState.adminRestaurantRefresh,
        }));
      }

      // Booking Refresh
      if (location.pathname === '/admin/restaurantrequest') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminRestaurantRequestRefresh: !prevState.adminRestaurantRequestRefresh,
        }));
      }

      // Account Refresh
      if (location.pathname === '/admin/restaurantRejectedRequest') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminRestaurantRejectedRefresh: !prevState.adminRestaurantRejectedRefresh,
        }));
      }
     
      // Account Approved Refresh 
      if (location.pathname === '/admin/meal') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminMealRefresh: !prevState.adminMealRefresh,
        }));
      }
      // Account Reject Refresh 
      if (location.pathname === '/admin/mealrequest') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminMealRequestRefresh: !prevState.adminMealRequestRefresh,
        }));
      }
      // Account Pending Refresh 
      if (location.pathname === '/admin/mealRejectedRequest') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminMealRejectedRefresh: !prevState.adminMealRejectedRefresh,
        }));
      }
      // Restaurant User
      if (location.pathname === '/admin/booking') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminBookingRefresh: !prevState.adminBookingRefresh,
        }));
      }
      if (location.pathname === '/admin/trip') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminTripRefresh: !prevState.adminTripRefresh,
        }));
      }
      if (location.pathname === '/admin/account') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminAccountRefresh: !prevState.adminAccountRefresh,
        }));
      }
      if (location.pathname === '/admin/accountapproved') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminAccountApprovedRefresh: !prevState.adminAccountApprovedRefresh,
        }));
      }
      if (location.pathname === '/admin/pendingaccountapproval') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminAccountPendingApprovalRefresh: !prevState.adminAccountPendingApprovalRefresh,
        }));
      }
      if (location.pathname === '/admin/accountrejected') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminAccountRejectedRefresh: !prevState.adminAccountRejectedRefresh,
        }));
      }
      if (location.pathname === '/admin/overallaccount') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminAccountOverallRefresh: !prevState.adminAccountOverallRefresh,
        }));
      }
      if (location.pathname === '/admin/payment/approved') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminPaymentApprovedRefresh: !prevState.adminPaymentApprovedRefresh,
        }));
      }
      if (location.pathname === '/admin/payment/pending') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminPaymentPendingRefresh: !prevState.adminPaymentPendingRefresh,
        }));
      }
      if (location.pathname === '/admin/payment/reject') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminPaymentRejectedRefresh: !prevState.adminPaymentRejectedRefresh,
        }));
      }
      if (location.pathname === '/usermanager/users') {
        setSideBarRefresh(prevState => ({
          ...prevState,
          adminUsersRefresh: !prevState.adminUsersRefresh,
        }));
      }
    }
  }, [clickCount, location.pathname]);





  return (
    <li>
      <SidebarNavLink
        to={route}
        onClick={handleClick}
        activeClassName="active"
      >
        {icon ? (
          <SidebarLinkIcon
            style={{
              color: 'skyblue',
            }}
            className={`lnr lnr-${icon}`}
          />
        ) : ''}
        <SidebarLinkTitle
          style={{
            color: color || colorText,
          }}
        >
          {title}
          {newLink ? (
            <NewBadge bg="custom">
              <span>New</span>
            </NewBadge>
          ) : ''}
        </SidebarLinkTitle>
      </SidebarNavLink>
    </li>
  );
};

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
};

SidebarLink.defaultProps = {
  icon: '',
  newLink: false,
  route: '/',
  onClick: () => {},
  color: '',
};

export default SidebarLink;

// region STYLES

export const SidebarNavLink = styled(NavLink)`
  height: 36px;
  width: 240px;
  transition: all 0.3s;
  position: relative;
  cursor: pointer;
  display: flex;
  padding: 11px 20px;
  overflow: hidden;
  background: transparent;
  border: none;
  color: ${colorText};
  text-align: ${left};
  font-size: 14px;

  &.active {
    background: ${sidebarColor};

    &:before {
      opacity: 1;
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    height: 100%;
    width: 2px;
    background: ${colorAccent};
    opacity: 0;
    transition: all 0.3s;
    ${left}: 0;
  }

  &:hover {
    text-decoration: none;
    background-color: ${colorHover};
    color: ${colorText};

    &:before {
      opacity: 1;
    }
  }

  @media screen and (min-width: 576px) {
    width: 100%;

    span {
      position: relative;
      animation: none;
      ${left}: 0;
    }
  }
`;

const NewBadge = styled(Badge)`
  width: 26px;
  height: 14px;
  background-color: ${colorRed};
  font-size: 8px;
  font-weight: 400;
  padding: 2px;
  line-height: 9px;
  position: relative;
  text-transform: uppercase;
  border-radius: 7px;
  ${marginLeft}: 5px;

  span {
    position: absolute;
    top: 3px;
    width: 26px;
    text-align: center;
    ${left}: 0;
  }
`;

export const SidebarLinkTitle = styled.span`
  margin: 0;
  font-size: 14px;
  line-height: 16px;
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const SidebarLinkIcon = styled.span`
  font-size: 13px;
  line-height: 13px;
  color: ${lighten(0.25, colorGray)};
  ${marginRight}: 10px;
`;

// endregion

// endregion
// endregion

// import React from 'react';
// import PropTypes from 'prop-types';
// import { Badge } from 'react-bootstrap';
// import { NavLink } from 'react-router-dom';
// import styled from 'styled-components';
// import { lighten } from 'polished';
// import {
//   colorAccent,
//   colorHover,
//   colorText,
//   sidebarColor,
//   colorRed,
//   colorGray,
// } from '@/utils/palette';
// import { 
//   left,
//   marginLeft,
//   marginRight,
// } from '@/utils/directions';

// const SidebarLink = ({
//   title, icon, newLink, route, onClick, color,
// }) => (
//   <li>
//     <SidebarNavLink
//       to={route}
//       onClick={onClick}
//       activeClassName="active"
//     >
//       {icon ? (
//         <SidebarLinkIcon
//           style={{
//         color: 'skyblue',
//       }}
//           className={`lnr lnr-${icon}`}
//         />
// ) : ''}
//       <SidebarLinkTitle 
//         style={{
//         color: color || colorText,
//        }}
//       >
//         {title}
//         {newLink ? (
//           <NewBadge bg="custom">
//             <span>New</span>
//           </NewBadge>
//         ) : ''}
//       </SidebarLinkTitle>
//     </SidebarNavLink>
//   </li>
// );

// SidebarLink.propTypes = {
//   title: PropTypes.string.isRequired,
//   icon: PropTypes.string,
//   newLink: PropTypes.bool,
//   route: PropTypes.string,
//   onClick: PropTypes.func,
//   color: PropTypes.string,
// };

// SidebarLink.defaultProps = {
//   icon: '',
//   newLink: false,
//   route: '/',
//   onClick: () => {},
//   color: '',
// };

// export default SidebarLink;

// // region STYLES

// export const SidebarNavLink = styled(NavLink)`
//   height: 36px;
//   width: 240px;
//   transition: all 0.3s;
//   position: relative;
//   cursor: pointer;
//   display: flex;
//   padding: 11px 20px;
//   overflow: hidden;
//   background: transparent;
//   border: none;
//   color: ${colorText};
//   text-align: ${left};
//   font-size: 14px;

//   &.active {
//     background: ${sidebarColor};

//     &:before {
//       opacity: 1;
//     }
//   }

//   &:before {
//     content: "";
//     position: absolute;
//     top: 0;
//     height: 100%;
//     width: 2px;
//     background: ${colorAccent};
//     opacity: 0;
//     transition: all 0.3s;
//     ${left}: 0;
//   }

//   &:hover {
//     text-decoration: none;
//     // background-color: ${colorHover};
//     background-color: ${colorHover};
//     color: ${colorText};

//     &:before {
//       opacity: 1;
//     }
//   }

//   @media screen and (min-width: 576px) {
//     width: 100%;

//     span {
//       position: relative;
//       animation: none;
//       ${left}: 0;
//     }
//   }
// `;

// const NewBadge = styled(Badge)`
//   width: 26px;
//   height: 14px;
//   background-color: ${colorRed};
//   font-size: 8px;
//   font-weight: 400;
//   padding: 2px;
//   line-height: 9px;
//   position: relative;
//   text-transform: uppercase;
//   border-radius: 7px;
//   ${marginLeft}: 5px;

//   span {
//     position: absolute;
//     top: 3px;
//     width: 26px;
//     text-align: center;
//     ${left}: 0;
//   }
// `;

// export const SidebarLinkTitle = styled.span`
//   margin: 0;
//   font-size: 14px;
//   line-height: 16px;
//   position: relative;
//   display: flex;
//   align-items: center;
//   white-space: nowrap;
// `;

// export const SidebarLinkIcon = styled.span`
//   font-size: 13px;
//   line-height: 13px;
//   color: ${lighten(0.25, colorGray)};
//   ${marginRight}: 10px;
// `;

// // endregion
